import { useState, useEffect, useRef } from "react";
import { theme } from "../../../shared/styles/theme";
import { formatarDataBR } from "../../../utils/dates";
import { hojeISO } from "../../../shared/utils/dataNaoFutura";

interface InputExameProps {
  valor: any;
  editavel: boolean;
  tipo?: string;
  onSalvar: (valor: any) => void;
  validacao?: { cor: string; indicador: string } | null;
  inputRef?: (el: HTMLInputElement | null) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  dataKey?: string; // ✅ NOVO
}

export default function InputExame({
  valor,
  editavel,
  tipo = "number",
  onSalvar,
  validacao,
  inputRef,
  onKeyDown,
  dataKey, // ✅ NOVO
}: InputExameProps) {
  const [valorLocal, setValorLocal] = useState(valor || "");
  const estaFocadoRef = useRef(false);
  const navegandoRef = useRef(false);

  useEffect(() => {
    if (!estaFocadoRef.current) {
      setValorLocal(valor || "");
    }
  }, [valor]);

  const salvarValor = () => {
    const valorAtualString = String(valor || "");
    const valorLocalString = String(valorLocal || "");

    if (valorLocalString === valorAtualString) {
      return;
    }

    if (tipo === "number") {
      const valorLimpo = String(valorLocal).trim();
      if (valorLimpo === "") {
        onSalvar(undefined);
      } else {
        const numero = parseFloat(valorLimpo);
        if (!isNaN(numero)) {
          onSalvar(numero);
        }
      }
    } else if (tipo === "date") {
      onSalvar(valorLocal);
    } else {
      onSalvar(valorLocal);
    }
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.style.borderColor = "#d1d5db";
    e.target.style.boxShadow = "none";

    estaFocadoRef.current = false;

    if (navegandoRef.current) {
      navegandoRef.current = false;
      return;
    }

    salvarValor();
  };

  // MODO VISUALIZAÇÃO
  if (!editavel) {
    return (
      <div
        style={{
          padding: "6px 8px",
          borderRadius: "6px",
          fontSize: "13px",
          fontFamily: theme.fonts.sans,
          fontWeight: validacao ? "600" : "normal",
          color: validacao?.cor || theme.gray[900],
          background: validacao ? `${validacao.cor}15` : "transparent",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "4px",
        }}
      >
        {tipo === "date" && valor ? formatarDataBR(valor) : valor || "-"}
        {validacao && (
          <span style={{ fontSize: "11px", fontWeight: "bold" }}>
            {validacao.indicador}
          </span>
        )}
      </div>
    );
  }

  // MODO EDIÇÃO
  return (
    <input
      ref={inputRef}
      type={tipo}
      data-key={dataKey} // ✅ NOVO
      {...(tipo === "date" ? { max: hojeISO() } : {})}
      name={`input-${Math.random()}`}
      value={valorLocal}
      onChange={(e) => setValorLocal(e.target.value)}
      onBlur={handleBlur}
      onKeyDown={(e) => {
        if (e.key === "Tab") {
          // Para campos date, deixar o browser navegar internamente (dia→mês→ano)
          if (tipo === "date") {
            return;
          }
          e.preventDefault();
          e.stopPropagation();

          navegandoRef.current = true;
          salvarValor();

          setTimeout(() => {
            if (onKeyDown) {
              onKeyDown(e);
            }
          }, 80);
        }

        if (e.key === "Enter") {
          e.preventDefault();
          e.stopPropagation();

          navegandoRef.current = true;
          salvarValor();

          setTimeout(() => {
            if (onKeyDown) {
              onKeyDown(e);
            }
          }, 80);
        }
      }}
      onWheel={(e) => e.currentTarget.blur()}
      style={{
        width: "100%",
        boxSizing: "border-box" as const,
        padding: "4px 4px",
        border: "1px solid #d1d5db",
        borderRadius: "6px",
        fontSize: "13px",
        outline: "none",
        fontFamily: theme.fonts.sans,
        textAlign: "center",
      }}
      step="any"
      tabIndex={0}
      onFocus={(e) => {
        estaFocadoRef.current = true;
        e.target.style.borderColor = theme.primary[500];
        e.target.style.boxShadow = `0 0 0 2px ${theme.primary[100]}`;
      }}
    />
  );
}
